import { Card } from "flowbite-react";
import React from "react";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import Enderecos from "../../common/query/Enderecos";
import Emails from "../../common/query/Emails";
import Telefones from "../../common/query/Telefones";
import Sociedade from "../../common/query/Sociedade";
import {
  countDadosCadastrais,
  formatDocument,
  formatToReal,
} from "../../../utils/utils";

const CadastralPJQuery = ({ data, dataFull }) => {
  const totalDadosCadastrais = Array.isArray(dataFull)
    ? dataFull.reduce((acc, item) => acc + countDadosCadastrais(item), 0)
    : countDadosCadastrais(dataFull);

  // Só renderiza se houver exatamente 1
  const podeRenderizarDadosCadastrais = totalDadosCadastrais < 3;
  return (
    <>
      {podeRenderizarDadosCadastrais && (
        <>
          {" "}
          <TitleStripe>Dados Cadastrais</TitleStripe>
          <div className="border border-gray-200 rounded-xl p-6 bg-white">
            <div className="grid grid-cols-2 gap-6 text-base">
              <div>
                <p className="text-gray-500 font-medium">Razão Social</p>
                <p className="text-gray-800">
                  {data?.dadosCadastrais?.razaoSocial || "Indisponível"}
                </p>
              </div>

              <div>
                <p className="text-gray-500 font-medium">CNPJ</p>
                <p className="text-gray-800">
                  {formatDocument(data?.dadosCadastrais?.cnpj) ||
                    "Indisponível"}
                </p>
              </div>

              <div>
                <p className="text-gray-500 font-medium">Nome Fantasia</p>
                <p className="text-gray-800">
                  {data?.dadosCadastrais?.nomeFantasia || "Indisponível"}
                </p>
              </div>

              <div>
                <p className="text-gray-500 font-medium">Situação</p>
                <span
                  className={`inline-block px-2 py-1 rounded-md text-white font-semibold text-sm ${
                    data?.dadosCadastrais?.situacao?.toUpperCase() === "ATIVA"
                      ? "bg-green-600"
                      : "bg-red-500"
                  }`}
                >
                  {data?.dadosCadastrais?.situacao || "Indisponível"}
                </span>
              </div>

              <div>
                <p className="text-gray-500 font-medium">Data de Fundação</p>
                <p className="text-gray-800">
                  {data?.dadosCadastrais?.dataFundacao || "Indisponível"}
                </p>
              </div>

              <div>
                <p className="text-gray-500 font-medium">Capital Social</p>
                <p className="text-gray-800">
                  {formatToReal(data?.dadosCadastrais?.capitalInicial) ||
                    "Indisponível"}
                </p>
              </div>
            </div>
          </div>
        </>
      )}

      {data?.socios && (
        <div>
          <TitleStripe>Sócios</TitleStripe>
          {data?.socios?.length > 0 ? (
            <Sociedade socios={data?.socios} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}

      {data?.enderecos && (
        <div>
          <TitleStripe>Endereços</TitleStripe>
          {data?.enderecos?.length > 0 ? (
            <Enderecos enderecos={data?.enderecos} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}

      {data?.emails && (
        <div>
          <TitleStripe>E-mails</TitleStripe>
          {data?.emails?.length > 0 ? (
            <Emails emails={data?.emails} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}

      {data?.telefones && (
        <div>
          <TitleStripe>Telefones</TitleStripe>
          {data?.telefones?.length > 0 ? (
            <Telefones telefones={data?.telefones} />
          ) : (
            <NoOcurrence />
          )}
        </div>
      )}
    </>
  );
};

export default CadastralPJQuery;
